import React, { createContext, useContext } from 'react';
import { useCustomDomain } from '../hooks/useCustomDomain';

const CustomDomainContext = createContext({
  isCustomDomain: false,
  organizationId: null,
  restaurantId: null,
  type: null,
  loading: true,
  error: null,
});

export function CustomDomainProvider({ children }) {
  const customDomain = useCustomDomain();
  return (
    <CustomDomainContext.Provider value={customDomain}>
      {children}
    </CustomDomainContext.Provider>
  );
}

export function useCustomDomainContext() {
  return useContext(CustomDomainContext);
}
